import { createContext, useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { ClientType } from '__generated__/GQL';

import { Client, Contact } from '../../../pages/Details/types';

type NewClient = Omit<Client, 'clientId'> & {
  clientId?: string;
};

type NewContact = Omit<Contact, 'clientId'> & {
  clientId?: string;
};

export type ClientContactForm = Contact | NewContact;

export type ClientForm = Omit<NewClient | Client, 'contacts'> & {
  contacts: ClientContactForm[];
  email?: string;
  phone?: string;
};

export const DEFAULT_CLIENT: ClientForm = {
  city: '',
  contacts: [],
  country: 'FR',
  legalRegistrationNumber: '',
  name: '',
  street: '',
  type: ClientType.Organization,
  vatId: '',
  zip: '',
};

export const createEmptyClientContact = (): NewContact => ({
  clientContactId: uuidv4(),
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
});

export const CLIENT_SAVE_CHANGES_ALERT_KEY = `@InvoiceClient:alert_save_changes`;

interface ClientModalContextState {
  client: ClientForm;
  isClientOrganization: boolean;
  setClient: (client: ClientForm) => void;
  setIsClientOrganization: (isClientOrganization: boolean) => void;
}

/**
 * Context for the whole client modal create/edit flow
 */
export const ClientModalContext = createContext<ClientModalContextState>({
  client: DEFAULT_CLIENT,
  isClientOrganization: true,
  setClient: () => undefined,
  setIsClientOrganization: () => undefined,
});

export const useClientFormModalContext = () => {
  const context = useContext(ClientModalContext);
  if (!context) {
    throw new Error(
      '"useClientFormModalContext" must be used within a ClientModalContextProvider',
    );
  }
  return context;
};
